import React, {useState, useEffect, useRef} from 'react';
import {
  Link,
  useParams,
  useHistory
} from "react-router-dom";
import BundleForm from '../../components/BundleEditForm';
import {uploadFile} from '../../Utils.js';
import slugify from 'slugify';

export default function AccountBundleAdd({ showMessage }) {
  const [product, setProduct] = useState({});
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState();
  const [login, setLogin] = useState(false);
  const [valid, setValid] = useState('');

  document.title = 'Add a New Bundle | Asterism Admin'

  let history = useHistory();

  const newCover = useRef(null);

  const setDefaultBundle = () => {
    setProduct({
      "title": "",
      "subtitle": "",
      "slug": "",
      "public": true,
      "description": "",
      "categories": [],
      "prices": {
        "list": 0.00,
        "retail": 0.00,
        "sale": 0.00,
        "enableSale": false,
        "retailStripe": '',
        "saleStripe": ''
      },
      "dimension": {
        "height": 7,
        "width": 4.5,
        "thickness": "0",
        "weight": "0"
      },
      "cover": "",
      "includes": "",
      "related": ""
    });
  }

  useEffect(() => {
    setDefaultBundle();
  }, []);

  const intoSlug = () => {
    if (product.title) {
      return slugify(product.title, {lower: true, strict: true, });
    } else {
      return '';
    }
  }

  const submit = async (another) => {
    if (!product.title) {
      showMessage({text: 'Bundle must have a title', temp: true, type: 'warn'});
      return;
    }
    let newBook = {...product}
    newBook.slug = intoSlug();
    setUploading(true);
    if (newCover.current && newCover.current.files.length > 0) {
      showMessage({text: 'Hold tight! We\'re uploading your files', temp: true, type: 'info'});
      newBook.cover = await window.ASTERISM.uploadFile(newCover);
    }
    setUploading(false);
    let data = await window.ASTERISM.makeRequest('create-bundle', 'POST', newBook)
    if (data.ok) {
      showMessage({text: 'Bundle successfully created!', temp: true, type: 'success'});
      if (another) {
        setDefaultBundle();
      } else {
        history.push(`/my-account/bundle/${data.id}`);
      }
    } else {
      showMessage({text: 'Something went wrong.', temp: true, type: 'warn'});
    }
  }

  if (error || !product.prices) {
    return (
      <div className='edit-bar'><div className='edit-title'>{error} {login && <Link to={`/login?return=${window.location.pathname}`}><button className='secondary-submit'>Login</button></Link>}</div></div>
    )
  }

  return (
    <div className=''>
      <div className='edit-bar'>
        <Link className='back-link' to='/my-account/bundles'>⟵ Back to bundles</Link>
        <div>
          <button className='main-submit' onClick={() => {submit(false)}}>Save</button>
          <button className='main-submit' onClick={() => {submit(true)}}>Save and Create Another</button>
        </div>
      </div>
      <BundleForm setProduct={setProduct} product={product} newCover={newCover} uploading={uploading}/>
    </div>
  )
}
